import { AgColDefsI, AgGridI, paginationModel } from "../../shared/common-components/ag-grid/ag-grid.model";
import { CheckboxCellrenderComponent } from "../../shared/common-components/ag-grid/checkbox-cellrender/checkbox-cellrender.component";
import { CustomHeaderComponent } from "../../shared/common-components/ag-grid/custom-header/custom-header.component";
import { ResetDeleteIconComponent } from "../../shared/common-components/ag-grid/reset-delete-icon/reset-delete-icon.component";
import { TextRendererComponent } from "../../shared/common-components/ag-grid/text-renderer/text-renderer.component";
import { TextSvgCellrenderComponent } from "../../shared/common-components/ag-grid/text-svg-cellrender/text-svg-cellrender.component";
import { StatusColWidth, ActionColWidth, NameColWidth, DateColWidth, InfoDataColWidth, ContactColWidth } from "../../shared/enum/common-enum";

export class DisplayBoardRegistration {
}


const Active: AgColDefsI = {
  headerName: "Status",
  field: 'active',
  minWidth: StatusColWidth.minWidth,
  maxWidth: StatusColWidth.maxWidth,
  headerComponent: CustomHeaderComponent,
  sortable: false,
  editable: false,
  resizable: false,
  headerClass: 'custom-column-group-cell ag_header_center',
  cellClass: 'custom-column-group-cell d-flex align-items-center justify-content-center',
  cellRenderer: CheckboxCellrenderComponent,  
  cellRendererParams: { confirmPopup:true},
};

  const Action: AgColDefsI = {
    headerName: "", 
    field: 'delete', 
    maxWidth: ActionColWidth.maxWidth,
    sortable: false,
    editable:false,
    headerComponentParams:{enablePlusIcon:true},
    cellRendererParams: {
    isDeleteIcon:true,
    editIcon: false,
    },
    cellRenderer:ResetDeleteIconComponent,
    lockPinned:true,
    pinned: 'right',
    headerClass: 'ag-header-cell-center mx-1',
    cellStyle:'cursor-pointer'
   
    
    
  };

const ShopName: AgColDefsI = {
    headerName: "Shop Name",
    field: 'shopName',
    headerComponent: CustomHeaderComponent,
    minWidth: NameColWidth.minWidth,
    // maxWidth: NameColWidth.maxWidth,
    sortable: true,
    editable: false,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer: TextRendererComponent
};

const MobileNo: AgColDefsI = {
    headerName: "Mobile No",
    field: 'mobileNo',
    headerComponent: CustomHeaderComponent,
    minWidth: ContactColWidth.minWidth,
    maxWidth: ContactColWidth.maxWidth,
    sortable: true,
    editable: false,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer: TextRendererComponent
};

const RegisteredDate: AgColDefsI = {
  headerName: "Registered Date",
  field: "registrationDate",
  headerComponent: CustomHeaderComponent,
  minWidth: DateColWidth.minWidth,
  maxWidth: DateColWidth.maxWidth,
  sortable: true,
  editable: false,
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell d-flex align-item-center mx-0",
  cellRenderer: TextSvgCellrenderComponent,
  cellRendererParams: { isCenter: true },
};

const Email: AgColDefsI = {
    headerName: "Email",
    field: 'email',
    headerComponent: CustomHeaderComponent,
    minWidth: NameColWidth.minWidth,
    // maxWidth: NameColWidth.maxWidth,
    sortable: true,
    editable: false,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer: TextRendererComponent
};

const Country: AgColDefsI = {
    headerName: "Country",
    field: 'country',
    headerComponent: CustomHeaderComponent,
    minWidth: InfoDataColWidth.minWidth,
    maxWidth: InfoDataColWidth.maxWidth,
    sortable: true,
    editable: false,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer: TextRendererComponent
};

export const DisplayBaordResistrationListColumnDef: AgColDefsI[] = [
    Email,
    ShopName,
    MobileNo,
    Country,
    RegisteredDate,
    Active,
    Action
]
export const AgGridDataModelDisplayBoardResistrationList: AgGridI = {
    colDefs: DisplayBaordResistrationListColumnDef,
    rowSelection: "multiple",
    rowHeight: 40,


}

export class displayBoardRegistrationRequestModel extends paginationModel{
    fromDate: string |null;
    toDate: string |null;;
}